import { useEffect, useState } from 'react';
import { GroupService } from '../../Services/GroupService';
import { WebApiMemberDtoMemberListResultDto, WebApiServicesDataTransferObjectsGroupServiceGroupResultDto } from '../../Repository/eventbookyapi';
import { useAuth } from '../../Contexts/AuthContext';
import { TextService } from '../../Services/TextService';
import LeftMenu from '../Users/LeftMenu';
import { MemberService } from '../../Services/MemberService';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { AddMultipleFortnoxInvoicesForm } from '../../Components/Users/AddMultipleFortnoxInvoices';

const AdminCreateFortnoxInvoices = () => {
  const [groups, setGroups] = useState([] as WebApiServicesDataTransferObjectsGroupServiceGroupResultDto[]);
  const [memberResult, setMemberResult] = useState({} as WebApiMemberDtoMemberListResultDto);

  const { user } = useAuth();
  const GetText = TextService.GetText;

  useEffect(() => {
    GroupService.GetGroupsIncludingAllMembers().then(result => {

      result.forEach(element => {
        if (element.isDefaultGroup) {
          element.name = GetText("MemberList_DefaultAllMembersName");
        }
      });
      setGroups(result);
    });

    MemberService.GetAllMembers().then(result => {
      setMemberResult(result);
    });
  }, []);

  return <LayoutLeftMenu title={GetText("AdminCreateFortnoxInvoices_Title")} menu={<LeftMenu selected={"sendEmail"} />}>
    {GetText("AdminCreateFortnoxInvoices_Description")}
    <AddMultipleFortnoxInvoicesForm user={user} groups={groups} memberResult={memberResult} />
  </LayoutLeftMenu>
};

export default AdminCreateFortnoxInvoices;
